<p-dialog
  header="Validar Estado"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '100%', maxWidth: '500px', maxHeight: '90vh' }"
  [breakpoints]="{ '640px': 'calc(100vw - 2rem)' }"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <div class="content-container" *ngIf="!isLoading">
    <!-- Estado de la solicitud -->
    <div class="progress-bar">
      <div class="line-background"></div>
      <div
        class="line-active"
        [style.width.%]="(currentStep / steps.length) * 100"
        [ngClass]="{
          'line-accepted': status === 'aprobado',
          'line-rejected': status === 'rechazado'
        }"
      ></div>

      <div *ngFor="let item of steps; let i = index" class="step">
        <div class="circle-container">
          <div
            class="circle"
            [ngClass]="{
              active: i < currentStep,
              current: i === currentStep - 1,
              accepted: status === 'aprobado' && i === steps.length - 1,
              rejected: status === 'rechazado' && i === currentStep - 1
            }"
          ></div>
        </div>

        <div
          class="label"
          [ngClass]="{
            active: i < currentStep,
            current: i === currentStep - 1,
            'rejected-label': status === 'rechazado' && i === currentStep - 1
          }"
        >
          {{ getStepLabel(i, status) }}
        </div>
      </div>
    </div>

    <!-- Detalles de la solicitud -->
    <div class="p-field mt-4">
      <div class="flex flex-column gap-5">
        <div>
            <p class="text-orange-400">Fecha de Inicio</p>
            <p>{{ dateStart }}</p>
          </div>
  
          <div>
            <p class="text-orange-400">Fecha de Fin</p>
            <p>{{ dateEnd }}</p>
          </div>
      </div>
    </div>

    <div class="document-section" *ngIf="viewDocument">
      <span class="document-label">{{ showButtons ? 'Documento original' : 'Documento' }}</span>
      <button type="button" class="document-card" (click)="downloadFile()">
        <i class="pi pi-file-pdf"></i>
        <span class="document-details">
          <strong>{{ originalFileName }}</strong>
          <small>Ver documento</small>
        </span>
      </button>
    </div>

    <div class="field" *ngIf="showButtons">
      <label class="font-semibold">Documento firmado</label>
      <div
        class="file-container"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <div
          class="file-preview"
          (click)="openFileUpload('pdf')"
        >
          <div class="custom-file-display">
            <div class="custom-file-top">
              <i
                [ngClass]="
                  selectedFileName ? 'pi pi-file-pdf' : 'pi pi-plus-circle'
                "
              ></i>
              <span [title]="selectedFileName || ''">{{ selectedFileName || "Subir un archivo" }}</span>
            </div>

            <p-divider *ngIf="!selectedFileName" align="center" type="solid">
              o
            </p-divider>

            <span *ngIf="!selectedFileName">Arrástralo aquí</span>
          </div>
        </div>
      </div>

      <button
        *ngIf="selectedFileName"
        type="button"
        class="remove-file"
        (click)="removeFile()"
      >
        Quitar archivo
      </button>

      <div
        style="
          color: grey;
          font-size: 0.75rem;
          text-align: center;
          display: flex;
          flex-direction: column;
        "
      >
        <p style="padding: 0; margin: 0">Formatos admitidos: pdf.</p>
        <p style="padding: 0; margin: 0; line-height: 0.5">
          Tamaño máximo de archivo: 10 MB.
        </p>
      </div>

      <p-fileUpload
        #pdfUploader
        [accept]="'application/pdf'"
        [maxFileSize]="10000000"
        (onSelect)="onChangeFile($event)"
        [style]="{ display: 'none' }"
      ></p-fileUpload>
    </div>

    <!-- Botones de aprobación / rechazo -->
    <div class="submit-button" *ngIf="showButtons">
      <button
        pButton
        type="button"
        [label]="primaryButtonLabel"
        class="approve-button"
        (click)="onPrimaryButtonClick()"
        [disabled]="validateForm()"
      ></button>
      <button
        pButton
        type="button"
        label="CANCELAR"
        class="reject-button"
        (click)="closeDialog()"
      ></button>
    </div>
  </div>
</p-dialog>
